<div class="content-body default-height">
    <!-- Breadcrumb  -->
    <app-breadcrumb [breadcrumb]="breadcrumbList" [addProperty]="'Back'" (addEvent)="goBackToList($event)"> </app-breadcrumb>
    <div class="container-fluid">
      <app-owner-overview (profileDetailsEvent)="getUserDetails($event)"></app-owner-overview>

      <div class="tab-content" id="tabContentMyProfileBottom">
        <div class="card">
         <div class="card-header-line">
             <div class="row m-2" *ngIf="userProperties?.length">
            <div class="col-md-6">
                 <select class="form-control width320" (change)="getPropertyBills()" [(ngModel)]="choosenProperty">
                    <option value="" selected disabled>Select Property</option>
                    <option *ngFor="let property of userProperties" [value]="property.uid">
                         {{property.name }}
                    </option>
                 </select>
                 </div>
        </div>
        </div>
        <div class="row">
            <div class="col-xl-12">
            <div class="table-responsive active-projects style-1 ItemsCheckboxSec shorting dataTables_wrapper" *ngIf="ownerBills?.length">
                <table id="empoloyees-tbl" class="table mb-0">
                    <thead>
                        <tr>
                            <th>Bill Name</th>
                            <th>Bill Type</th>
                            <th class="category-width">Category</th>
                            <th>Bill Amount</th>
                            <th>Paid Date</th>
                            <th>Created At</th>
                            <th>Payment Status</th>
                            <th class="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for(bill of ownerBills; track bill){
                        <tr>
                            <td>
                                <span>{{ bill.name }}</span>
                            </td>
                            <td>
                                <span>{{ bill.bill_type == "1" ? "Rent/Security Deposit" : bill.bill_type == "2" ? "Expenses" : "Company Fee" }}</span>
                            </td>
                            <td>
                                <span>{{ bill.category }}</span>
                            </td>
                            <td>
                                <span>{{ bill.amount }}</span>
                            </td>
                            <td>
                              <span>{{ bill.paid_date | date:'dd-MM-yyyy' }}</span>
                            </td>
                            <td>
                              <span>{{ bill.created_at | date:'dd-MM-yyyy' }}</span>
                            </td>
                            <td>
                                @if(bill.status == 'Pending'){
                                <span class="badge light badge-info me-2">Pending</span>
                                } @else if(bill.status == 'Paid'){
                                <span class="badge light badge-success me-2">Paid</span>
                                } @else if(bill.status == 'Unpaid'){
                                <span class="badge light badge-warning me-2">Unpaid</span>
                                } @else {
                                <span class="badge light badge-danger me-2">Cancelled</span>
                                }

                            </td>
                            <td class="text-center">
                                <div class="img-wrapper">
                                    <button type="button" class="btn btn-info shadow btn-xs sharp me-2" (click)="viewInvoice(bill.uid)">
                                        <i class="fa fa-download"></i>
                                    </button>
                                    <div class="tooltip-text">Invoice</div>
                                </div>
                            </td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
            <p class="text-center mt-2 no-docs" *ngIf="!ownerBills?.length">No bills found</p>
        </div>
    </div>
</div>
        </div>
    </div>
</div>

